import { render, staticRenderFns } from "./DonationRecord.vue?vue&type=template&id=3bfd1c72"
import script from "./DonationRecord.vue?vue&type=script&lang=js"
export * from "./DonationRecord.vue?vue&type=script&lang=js"
import style0 from "./DonationRecord.vue?vue&type=style&index=0&id=3bfd1c72&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports